import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ChatDetail, ChatWrite, UserProfile } from 'types/api'
import type { BaseParams, RoleAccess } from 'types/utils'

export type createChatParams<Role extends UserProfile['role']> = BaseParams<
  RoleAccess<Role, ChatWrite>,
  'POST'
>

export function useCreateChat<Role extends UserProfile['role']>() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function createChat({ body }: createChatParams<Role>) {
    const res = await apiClient.post<ChatDetail>(`${SNA_PREFIX}chats/`, body)
    return res.data
  }

  return useMutation({
    mutationFn: createChat,
    onSuccess: () => {
      toast.success({ message: t('applicationCreated') })
      queryClient.invalidateQueries({ queryKey: ['chats'] })
    },
    onError // Updated to use useOnError
  })
}
